import styles from '../../styles/products.module.css';
import { ReactElement } from 'react';

interface ProductRobotDetailWrapProps {
    image: string;
    imageWebp: string;
    titleComponent: ReactElement;
    detailComponent: ReactElement;
    reverse?: string;
}

const ProductRobotDetailWrap: React.FC<ProductRobotDetailWrapProps> = ({ image, imageWebp, titleComponent, detailComponent, reverse }) => {
    return (

        <div className={`${styles.robotW} ${reverse} ${styles.amrRobotW}`}>
            <div className={styles.robotImage}>
                <img src={image} srcSet={imageWebp} alt="ar247_robot" loading="lazy" />
            </div>
            <div className={styles.contentW}>
                {titleComponent}
                {detailComponent}
            </div>
        </div>

    )
}

export default ProductRobotDetailWrap;